import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Where the staff hub lives. In production it is its own subdomain
// (e.g. https://hub.fortifyid.com.au, served at root); in dev it is path-routed
// at /app behind the shared host. VITE_STAFF_BASE_URL is injected at build time.
const STAFF_BASE = ((import.meta.env.VITE_STAFF_BASE_URL as string) || "/app").replace(/\/$/, "");

export const APP_BASE_URL = `${STAFF_BASE}/`;
export const APP_SIGN_IN_URL = `${STAFF_BASE}/sign-in`;
export const APP_SIGN_UP_URL = `${STAFF_BASE}/sign-up`;

// Absolute base of the API server (e.g. https://api.fortifyid.com.au) when the
// marketing site is on its own subdomain and must call the API cross-origin.
// Empty in dev / the single path-routed deployment, where the API is reached at
// the relative same-origin /api path. VITE_API_BASE_URL is injected at build.
export const API_BASE_URL = ((import.meta.env.VITE_API_BASE_URL as string) || "").replace(/\/$/, "");

// Build an absolute API URL when a cross-origin API base is configured, else
// return the path unchanged so same-origin /api calls keep working.
export function apiUrl(path: string): string {
  return API_BASE_URL ? `${API_BASE_URL}${path}` : path;
}

export function trackEvent(name: string, props?: Record<string, unknown>) {
  const w = window as unknown as { plausible?: (n: string, o?: { props?: Record<string, unknown> }) => void };
  w.plausible?.(name, props ? { props } : undefined);
}
